import ListSelectField from "./ListSelectField";

export const DictionaryField = ({ optionsDictionary, ...props }) => {
  return (
    <ListSelectField
      options={Object.keys(optionsDictionary).map((k) => [
        k,
        optionsDictionary[k],
      ])}
      {...props}
    />
  );
};
export default DictionaryField;
